export default "__VITE_ASSET__DnIaN3jN__"